import * as React from 'react';
import { CurrentRenderDirectionContextProvider } from '../../../../utils/dimensions/directionDimension';
import { useTableWrapping } from '../../wrapping/hooks';
export var CurrentRenderDirectionContextByWrappingProvider = function (props) {
    var children = props.children;
    var wrapping = useTableWrapping();
    return (React.createElement(CurrentRenderDirectionContextProvider, { currentDirection: wrapping !== 'vertical' ? 'vertical' : 'horizontal' }, children));
};
